/** Публичная страница одной статьи блога в режиме чтения. */
import type { PartialBlock } from "@blocknote/core";
import { BlockNoteView } from "@blocknote/mantine";
import "@blocknote/mantine/style.css";
import { useCreateBlockNote } from "@blocknote/react";
import { Link, useParams } from "react-router-dom";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { useThemeStore } from "@/shared/store";
import { UIKit } from "@/shared/ui";

import "@blocknote/core/fonts/inter.css";

export const BlogArticlePage = () => {
	const { article: articlePath = "" } = useParams();
	const id = articlePath.slice(-36);
	const { data: article, isPending } = apiHooks.blog.useBlogArticle(id);

	return (
		<main className="flex-1 overflow-y-auto bg-bg px-5 py-8">
			<div className="mx-auto max-w-3xl">
				<Link className="text-sm font-medium text-accent hover:underline" to={routerPaths.blog}>
					Ко всем статьям
				</Link>
				{isPending ? (
					<UIKit.Text className="mt-8 text-ink">Загружаем статью...</UIKit.Text>
				) : article === null ? (
					<UIKit.Text className="mt-8 text-ink">Статья не найдена.</UIKit.Text>
				) : (
					<article className="mt-8">
						<UIKit.Text size="small" className="text-ink">
							{new Date(article.createdAt).toLocaleDateString("ru-RU")}
						</UIKit.Text>
						<h1 className="mt-3 text-3xl font-semibold">{article.title}</h1>
						<UIKit.Text className="mt-4 text-ink">{article.excerpt}</UIKit.Text>
						<BlogArticleContent content={article.content} />
					</article>
				)}
			</div>
		</main>
	);
};

const BlogArticleContent = ({ content }: { content: unknown[] }) => {
	const colorTheme = useThemeStore((state) => state.colorTheme);
	const editor = useCreateBlockNote({
		initialContent: content as PartialBlock[],
	});

	return (
		<BlockNoteView
			className="blog-content mt-8 bg-surface p-4"
			editable={false}
			editor={editor}
			theme={colorTheme}
		/>
	);
};
